// extracted by mini-css-extract-plugin
export var starRatings = "index-module--star-ratings--1ff5d";
export var starRatingsRating = "index-module--star-ratings-rating--fed94";